module.exports = __webpack_public_path__ + "static/media/hand.4c411b1f.png";